import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Triangle, getAmenityName } from '../../utils';

import { AccordionList, AccordionBody, AccordionHeader, AccordionHeading, AccordionIcon, AccordionArrow, AccordionContent, FeaturesList } from './styles';

class Accordion extends Component {
  static propTypes = {
    itemsList: PropTypes.instanceOf(Array),
    additionalList: PropTypes.instanceOf(Array),
  };

  state = {
    currentItem: null,
  };

  handleAccordionItemClick = evt => {
    const { target } = evt;
    const button = target.closest('button');

    if (button) {
      const { value } = button;

      this.setState(prevState => ({
        currentItem: prevState.currentItem === value ? null : value,
      }));
    }
  };

  render() {
    const { currentItem } = this.state;
    const { itemsList, additionalList } = this.props;

    return (
      <AccordionList onClick={this.handleAccordionItemClick}>
        {itemsList.map(item => (
          <li key={item.type}>
            <AccordionBody>
              <AccordionHeader value={item.type}>
                <AccordionIcon>
                  {getAmenityName(item.type).icon}
                </AccordionIcon>
                <AccordionHeading>{getAmenityName(item.type).name}</AccordionHeading>
                <AccordionArrow isOpen={currentItem === item.type}>
                  <Triangle width={11} height={7} />
                </AccordionArrow>
              </AccordionHeader>
              {currentItem === item.type && (
                <AccordionContent>
                  <FeaturesList>
                    {item.list.map((feature, index) => <li key={feature + index} dangerouslySetInnerHTML={{ __html: feature }} />)}
                  </FeaturesList>
                </AccordionContent>
              )}
            </AccordionBody>
          </li>
        ))}
        {additionalList && (
          additionalList.map(item => {
            if (item.list && item.list.length !== 0) {
              return (
                <li key={item.type}>
                  <AccordionBody>
                    <AccordionHeader value={item.type}>
                      <AccordionIcon>
                        {getAmenityName(item.type).icon}
                      </AccordionIcon>
                      <AccordionHeading>{getAmenityName(item.type).name}</AccordionHeading>
                      <AccordionArrow isOpen={currentItem === item.type}>
                        <Triangle width={11} height={7} />
                      </AccordionArrow>
                    </AccordionHeader>
                    {currentItem === item.type && (
                      <AccordionContent>
                        <FeaturesList as="div" dangerouslySetInnerHTML={{ __html: item.list }} />
                      </AccordionContent>
                    )}
                  </AccordionBody>
                </li>
              )
            }

            return null;
          })
        )}
      </AccordionList>
    )
  }
}

export default Accordion;
